import React from 'react'
import classnames from 'classnames';

class SlideLayoutPreview extends React.Component {

  state = {
    mobile: false,
  };

  render() {
    const {layout, columns, selectedColumn, hideGrids } = this.props;
    const columnCount = layout.numberOfColumns ? new Array(Number(layout.numberOfColumns) + 1).join('1fr ').trim() : '1fr';
    const rowCount = layout.numberOfRows ? new Array(Number(layout.numberOfRows) + 1).join('1fr ').trim() : '1fr';
    const hGridLines = [...Array(Number(layout.numberOfColumns))].map((item, zz) => {
      const gridLineStyles = {
        position: 'absolute',
        top: '0',
        left: (100 / Number(layout.numberOfColumns)) * (zz + 1) + '%',
        height: '100%',
        width: '1px',
        borderRight: hideGrids ? 'none' : '1px dashed white'
      };
      return (<div key={`gl-${zz}`} style={gridLineStyles}/>)
    });

    const vGridLines = [...Array(Number(layout.numberOfRows))].map((item, zz) => {
      const gridLineStyles = {
        position: 'absolute',
        left: '0',
        top: (100 / Number(layout.numberOfRows)) * (zz + 1) + '%',
        width: '100%',
        height: '1px',
        borderTop: hideGrids ? 'none' : '1px dashed white'
      };
      return (<div key={`gl-${zz}`} style={gridLineStyles}/>)
    });

    return (
        <div style={ { position: 'relative', maxWidth: this.props.device === 'mobile' ? '200px' : '100%' } }>
          {/*<img onClick={ () => { this.setState(() => ({ mobile: !this.state.mobile }))} }*/}
          {/*     className="preview--mobile"*/}
          {/*     style={ { position: 'absolute', right: '0', top: '-32px' } }*/}
          {/*     src={`data:image/svg+xml,%3Csvg%20fill%3D%22%23${ hideGrids ? 'f9e7cc' : '333333' }%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20width%3D%2224%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M18.5%200h-14C3.12%200%202%201.12%202%202.5v19C2%2022.88%203.12%2024%204.5%2024h14c1.38%200%202.5-1.12%202.5-2.5v-19C21%201.12%2019.88%200%2018.5%200zm-7%2023c-.83%200-1.5-.67-1.5-1.5s.67-1.5%201.5-1.5%201.5.67%201.5%201.5-.67%201.5-1.5%201.5zm7.5-4H4V3h15v16z%22/%3E%0A%3C/svg%3E`} alt="Mobile"*/}
          {/*/>*/}
          <div style={{backgroundColor: '#333333', position: 'relative', overflow: 'hidden', resize: 'horizontal' }} className='form-preview__slidezz'>
            <div style={{
              display: 'grid',
              gridGap: layout.gridGap,
              gridTemplateColumns: columnCount,
              gridTemplateRows: rowCount,
              height: '300px'
            }}>
              {columns && columns.length > 0 && columns.map((item, index) => {
                const styles = {
                  gridColumnStart: item.columnStart,
                  gridColumnEnd: item.columnEnd,
                  gridRowEnd: item.rowEnd,
                  gridRowStart: item.rowStart,
                  alignSelf: item.vAlign,
                  justifySelf: item.hAlign,
                  backgroundImage: `url(${item.photo && item.photo.url && item.photo.url})`,
                  backgroundSize: item.imageAppearance.toLowerCase(),
                  backgroundPosition: item.imagePosition.toLowerCase(),
                  backgroundRepeat: 'no-repeat',
                  opacity: selectedColumn === index || hideGrids ? '1' : '0.5',
                  webkitFilter: selectedColumn === index || hideGrids ? '' : 'blur(1px)',
                  height: '100%',
                  width: '100%'
                };
                const classes = [{
                  'grid-item grid-item--has-border': true,
                  'cover': item.imageAppearance === 'Cover',
                  'contain': item.imageAppearance === 'Contain'
                }];
                return <div key={`c${index}`} style={styles} className={classnames(classes)}/>
              })}
            </div>
            <div style={{
              position: 'absolute',
              borderRight: hideGrids ? 'none' : '1px dashed white',
              height: '100%',
              width: '1px',
              top: '0'
            }}/>
            <div style={{
              position: 'absolute',
              borderTop: hideGrids ? 'none' : '1px dashed white',
              width: '100%',
              height: '1px',
              left: '0',
              top: 0
            }}/>
            {hGridLines}
            {vGridLines}
          </div>
        </div>
    );
  }

}

export default SlideLayoutPreview;



// WEBPACK FOOTER //
// ./src/containers/add/SlideLayoutPreview.js